import Vault from "./Vault";

export * from "./AirVent";
export * from "./Blinds";
export * from "./CookingPot";
export * from "./Fan";
export * from "./FireExtinguisher";
export * from "./Hammer";
export * from "./Refrigeator";
export * from "./ShowerHead";
export * from "./UnityPool";
export * from "./Vault";

export const Homing = {
  Vault,
};
